import React, { useEffect, useContext } from "react";
//import { useRouter } from "next/router";
//import Link from "next/link";
import Logo from "../../../assets/img/logo.jpg";
import Megamatch from "../../../assets/img/megamatch.png";
import { Row, Col, Card } from "react-bootstrap";

function Silbina() {
  //const router = useRouter();

  const onImageClick = (image) => {
    var filename = "";

    /*
    if (image.isVideo == 1) {
      filename = youtube_parser(image.path[0]);
    } else {
      filename = removeFileExtension(image.path[0]);
    }
    modifyImages(image);
    */

    window.history.pushState({}, "", `/images/${filename}`);
  };

  useEffect(() => {
    console.log("Silbina");
  }, []);

  return (
    <>
      <div className="row header-qr">
        <div className="col-6 container-image">
          <div className="d-flex justify-content-center h-100">
            <div className="image_outer_container">
              <div className="image_inner_container">
                <img
                  src={Logo}
                  style={{
                    height: "150px",
                    width: "100%",
                    borderRadius: "5% !important",
                  }}
                />
              </div>
            </div>
          </div>
          {/*
            <div className="profile-image-wrapper">
              <img
                src={
                  "https://aldealista.com/p/" +
                  village.villageData.profilePicture
                }
                alt="."
                className="profile-single-image"
              />
            </div>
              */}
        </div>
        <div
          className="col-6 container-text"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <p className="title-qr">Megamatch Silbina</p>
          <p className="region">Galicia</p>
          <p className="coordinates">Sil Bibei Navea</p>
        </div>
      </div>

      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          marginBottom: "30px",
          marginTop: "30px",
        }}
        className="footer-hr"
      >
        {/* Repeat this structure for each item */}
        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/teixeira" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/2VgrZxoelveqfEDV2htbJ5ke3k42_5-3-2023-1521-0.jpg"
                alt="A Teixeira"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"A Teixeira"}
                </p>
              </div>
            </Card>
          </a>
        </Col>
        {/* ... repeat for other columns */}

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/trives" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/bXF5pVZGXgeSJyCDJXCzSnMhCKH3_5-3-2023-153037-0.jpg"
                alt="A Pobra de Trives"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"A Pobra de Trives"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/castrocaldelas" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/KeNbOy7tCDYBhfn0P5dUrgp4QDg1_14-9-2022-105436-0.jpg"
                alt="Castro Caldelas"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"Castro Caldelas"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/chandrexadequeixa" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/NxkAHsL0jjdLLhPkdjocilS4K7q1_13-10-2022-173931-7.webp"
                alt="Chandrexa de Queixa"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"Chandrexa de Queixa"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/manzaneda" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/yv0tKX4dlDc6HsYU3MNULV81Izm1_30-1-2023-104929-0.jpg"
                alt="Manzaneda"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"Manzaneda"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/montederramo" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/3oN0dbpFG6YSOmqPhPPF81d29SD3_5-3-2023-1554-0.jpg"
                alt="Montederramo"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"Montederramo"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/paradadesil" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/GMMv2zQz70dGjNhiAM02HWQHSSa2_5-3-2023-15844-0.jpg"
                alt="Parada de Sil"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"Parada de Sil"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/sanxoanderio" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/profile2.jpg"
                alt="San Xoán de Rio"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"San Xoán de Rio"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/vianadobolo" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/T5Ym9hTnv5agvnM9cAuWytCj5tK2_5-3-2023-153932-0.webp"
                alt="Viana do Bolo"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"Viana do Bolo"}
                </p>
              </div>
            </Card>
          </a>
        </Col>

        <Col
          xs={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            marginTop: "35px",
          }}
        >
          <a href="https://aldealista.com/vilarinodeconso" target="_blank">
            <Card
              style={{
                width: "150px",
                height: "200px",
                position: "relative",
                border: "2px solid #343041",
                boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Card.Img
                variant="top"
                src="https://aldealista.com/p/BJCopKE8G9NSE4sygvFSN4fE9dG2_13-10-2022-182637-6.webp"
                alt="Vilariño de Conso"
                style={{ height: "100%" }}
              />
              <Card.ImgOverlay
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                }}
              />
              {/* Add other images and overlays as necessary */}
              <img
                src={Megamatch}
                style={{
                  position: "absolute",
                  top: 10, // Adjust positioning as needed
                  left: 10,
                  maxWidth: 55,
                  height: "auto",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "#fff",
                  width: "100%",
                  padding: "0 16px",
                }}
              >
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  {"Vilariño de Conso"}
                </p>
              </div>
            </Card>
          </a>
        </Col>
      </Row>
    </>
  );
}

export default Silbina;
